import styled from 'styled-components'
import { themeMedia, themeStyles } from '../../../styles/theme'

export const StyledUnavailabilityWrapper = styled.div`
  padding: 1em;
  box-sizing: border-box;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    margin: 1.5em 0 4.3em;
    text-align: center;
    color: ${(props) =>
      props?.reason === 'maintenance' ?
        themeStyles.colors.accentColors.secondary.main :
        themeStyles.colors.white.main};
  }

  ${themeMedia.tablet`
    background: ${themeStyles.colors.darkGreys[5].main};

    p {
      margin: 2.77em 0 1.1em;
    }
  `}
`
